import React, { useRef, useState } from 'react'
import { ReactComponent as EditTableIcon } from '../../../assets/EditTableIcon.svg'
import { ReactComponent as ViewTableDataIcon } from '../../../assets/ViewTableDataIcon.svg'
import { ReactComponent as AddTableDataIcon } from '../../../assets/AddTableDataIcon.svg'
import { saveCsv, extractDataFromCsvOrThrow, parseTableDataFromCsv } from '../../../utils/csvUtils.js'
import { httpGet, httpPut } from '../../../store/services/testServiceClient.js'
import { Button, Modal } from 'antd'
import TableViewModal from '../../../components/TableViewModal.jsx'

const EditableTableCell = ({
  scenarioIndex,
  scenario,
  testId,
  arg,
  cellId,
  getParameterFromCellId,
  projectId,
  showError,
  testPath,
  loadScenarios
}) => {
  const tableId = scenario.Arguments[scenarioIndex].Value.TableId
  const parentId = scenario.Arguments[scenarioIndex].Value.ParentId
  const tablecsv = useRef()
  const [storeTableCsvFile, setStoreTableCsvFile] = useState('')
  const [csvError, setCsvError] = useState('')
  const [tablePopupTitle, setTablePopupTitle] = useState('')
  const [isLoadingTableData, setIsLoadingTableData] = useState(false)
  const [isTableUploadModalVisible, setIsTableUploadModalVisible] = useState(false)
  const [isModalEditMode, setIsTableModalEditMode] = useState(false)
  const [isTableModalVisible, setIsTableModalVisible] = useState(false)
  const parameter = getParameterFromCellId(cellId)

  const showImportTableDialog = () => {
    setTablePopupTitle(`Import csv for '${parameter.Name}'`)
    setIsTableUploadModalVisible(true)
  }

  const getTable = async (projectId, tableId, parentId) => {
    const response = await httpGet(
      `projects/${projectId}/table/${tableId}/downloadFile?parentId=${parentId}`
    )
    return response.data
  }

  const viewTableData = async () => {
    const parameterName = parameter.Name
    setIsTableModalEditMode(false)
    setTablePopupTitle(`${scenario.Name} - ${parameterName}`)
    setIsTableModalVisible(true)
    setIsLoadingTableData(true)

    try {
      const csvContent = await getTable(projectId, tableId, parentId)
      setStoreTableCsvFile(csvContent)
    } catch (error) {
      showError('Error loading dataset table data')
    } finally {
      setIsLoadingTableData(false)
    }
  }

  const importTableCsv = () => {
    setIsTableModalEditMode(true)
    setIsTableModalVisible(true)
  }

  const uploadTableCsvData = () => {
    updateTableParameterValue(storeTableCsvFile)
    closeTableDataModal()
  }

  const updateTableParameterValue = async (csvFile) => {
    const paramId = cellId.split('-')[1]
    const formData = new FormData()
    formData.append('ScenarioId', scenario.Id)
    formData.append('ParameterId', paramId)
    formData.append('File', new Blob([csvFile]))

    try {
      await httpPut(`${testPath}/updateScenario`, formData)
      await loadScenarios()
    } catch (e) {
      showError(
        `Error updating argument value for ${parameter.Name} for dataset: ${scenario.Name}.`,
        e
      )
    }
  }

  const handleFileUpload = async (event) => {
    const csvFile = event.target.files[0]
    const validationResult = await extractDataFromCsvOrThrow(
      csvFile,
      parameter
    )
    if (validationResult.error) {
      setCsvError(validationResult.error)
    } else {
      setIsTableModalEditMode(true)
      setIsTableModalVisible(true)
      setStoreTableCsvFile(await csvFile.text())
      setCsvError('')
    }
  }

  const closeTableDataModal = () => {
    setStoreTableCsvFile('')
    setCsvError('')
    setIsTableUploadModalVisible(false)
    setIsTableModalVisible(false)
  }

  return (
    <>
      <td className='table-btn-td whitespace-nowrap border-solid border-1 border-gray-100 hover:bg-gray-100 text-center align-middle'>
        <Button
          id={
            arg.Value.length !== 0
              ? 'editTableDataButton'
              : 'addTableDataButton'
          }
          title={arg.Value.length !== 0 ? 'Edit Table Data' : 'Add Table Data'}
          className='table-btn'
          onClick={showImportTableDialog}
        >
          {arg.Value.length !== 0 ? (
            <EditTableIcon className='edit-table-icon' />
          ) : (
            <AddTableDataIcon className='add-table-data-icon' />
          )}
        </Button>
        <Button
          id='viewTableDataButton'
          className='table-btn'
          title={arg.Value.length !== 0 ? 'View Table Data' : 'No data added'}
          disabled={arg.Value.length === 0}
          onClick={viewTableData}
        >
          <ViewTableDataIcon
            className='view-table-icon'
            style={{
              filter: arg.Value.length === 0 ? 'grayscale(100%)' : 'none'
            }}
          />
        </Button>
      </td>
      <Modal
        visible={isTableUploadModalVisible}
        destroyOnClose
        onCancel={closeTableDataModal}
        footer={
          <>
            <Button
              className='active-btn'
              id='importBtn'
              disabled={csvError || !tablecsv.current?.files.length}
              onClick={importTableCsv}
            >
              Import
            </Button>
            <Button type='default' id='cancelBtn' onClick={closeTableDataModal}>
              Cancel
            </Button>
          </>
        }
        title='Import table data from a csv file'
      >
        <input
          type='file'
          onChange={handleFileUpload}
          ref={tablecsv}
          accept='.csv'
          id='csvfileinput'
        />
        {csvError && <p style={{ color: 'red' }}>{csvError}</p>}
      </Modal>
      <TableViewModal
        isModalVisible={isTableModalVisible}
        isEditMode={isModalEditMode}
        title={tablePopupTitle}
        tableData={parseTableDataFromCsv(storeTableCsvFile)}
        onConfirm={uploadTableCsvData}
        isLoading={isLoadingTableData}
        onCancel={closeTableDataModal}
        downloadTable={() => getTable(projectId, tableId, parentId)}
      />
    </>
  )
}

export default EditableTableCell
